module.exports = __webpack_public_path__ + "img/topicFood.f5821c37.webp";